import {
  GET_FINANCE_LIST,
  ADD_FINANCE,
  UPDATE_FINANCE,
  DELETE_FINANCE,
  SET_FILTER_TYPE_FINANCE,
  SET_CURRENT_FINANCE,
  CLEAR_CURRENT_FINANCE,
} from '@jumbo/constants/ActionTypes';
import { client } from 'services/http';
import { fetchError, fetchStart, fetchSuccess } from './Common';

//get list data
export const getFinaceList = params => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .get(`/share/v1/pay_offs`, { params: { ...params } })
      .then(data => {
        if (data.status === 200 || data.status === 202) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_FINANCE_LIST, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.response?.data?.errors?.base[0]));
      });
  };
};

export const setCurrentPayoff = payoff => {
  return dispatch => {
    dispatch({ type: SET_CURRENT_FINANCE, payload: payoff });
  };
};

export const clearCurrentPayoff = () => {
  return dispatch => {
    dispatch({ type: CLEAR_CURRENT_FINANCE });
  };
};

//create new pay off
export const addPayeoff = (params, history) => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .post(`share/v1/pay_offs`, { ...params })
      .then(data => {
        if (data.status === 200 || data.status === 202) {
          dispatch(fetchSuccess('لاگ جدید ثبت شد'));
          dispatch({ type: ADD_FINANCE, payload: data.data });
          history.push('/finance');
        } else {
          dispatch(fetchError('Something went wrong '));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.response?.data?.errors?.base[0]));
      });
  };
};

export const updatePayeoff = (params, id) => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .put(`share/v1/pay_offs/${id}`, { ...params })
      .then(data => {
        if (data.status === 200 || data.status === 202) {
          dispatch(fetchSuccess('تغییرات شما با موفقیت انجام شد'));
          dispatch({ type: UPDATE_FINANCE, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong '));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.response?.data?.errors?.base[0]));
      });
  };
};

export const DeleteFinance = id => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .delete(`/share/v1/pay_offs/${id}`)
      .then(data => {
        if (data.status === 200 || data.status === 202) {
          dispatch(fetchSuccess());
          dispatch({ type: DELETE_FINANCE, payload: id });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

//For setting Filtertype
export const setFinanceFilter = filterFinance => {
  return {
    type: SET_FILTER_TYPE_FINANCE,
    payload: filterFinance,
  };
};
